var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.d)+" "+_vm._s(_vm.dayString)+", "+_vm._s(_vm.h)+" "+_vm._s(_vm.hourString)+", "+_vm._s(_vm.m)+" "+_vm._s(_vm.minuteString)+" und "+_vm._s(_vm.s)+" "+_vm._s(_vm.secondString))])}
var staticRenderFns = []

export { render, staticRenderFns }